module.exports = __webpack_public_path__ + "img/161.49afe087.png";